export const MODULE_NAME = 'reports';
export const ACCESS_NAME = 'Reports';
